import styles from "./HourScrubber.module.css";

interface HourScrubberProps {
  /** Currently selected hour index (0–47). */
  hourIndex: number;
  onChange: (index: number) => void;
  /** ISO time strings from the wind grid, one per hour. Optional — used for label. */
  times?: string[];
}

function formatHourLabel(hourIndex: number, times?: string[]): string {
  const timeStr = times?.[hourIndex];
  if (timeStr) {
    // timeStr is a unix timestamp (seconds) or ISO string depending on API.
    const ts = typeof timeStr === "number" ? timeStr * 1000 : Number(timeStr) * 1000;
    if (!Number.isNaN(ts) && ts > 0) {
      const d = new Date(ts);
      const hh = String(d.getUTCHours()).padStart(2, "0");
      const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
      const day = dayNames[d.getUTCDay()] ?? "";
      return `${day} ${hh}:00 UTC`;
    }
  }
  // Fallback: relative hour label.
  const day = hourIndex < 24 ? "Today" : "Tomorrow";
  const hh = String(hourIndex % 24).padStart(2, "0");
  return `${day} ${hh}:00`;
}

export function HourScrubber({ hourIndex, onChange, times }: HourScrubberProps) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.label}>{formatHourLabel(hourIndex, times)}</div>
      <input
        type="range"
        min={0}
        max={47}
        value={hourIndex}
        onChange={(e) => onChange(Number(e.target.value))}
        className={styles.slider}
        aria-label="Select forecast hour"
      />
      <div className={styles.endpoints}>
        <span>Now</span>
        <span>+48h</span>
      </div>
    </div>
  );
}
